/**
 * Legacy blog post URL redirects mapping
 * Maps old Korean title-based URLs to new SEO-friendly slug URLs
 *
 * Used by middleware to handle 301 redirects for existing search engine indexed URLs
 */

export const POST_REDIRECTS: Record<string, string> = {
  // AWS & Cloud
  "SST에서 ECS(Fargate) 컨테이너로 마이그레이션":
    "migrate-to-ecs-fargate-from-sst",
  "AWS SAA C03 - 합격 후기 🎖️": "aws-saa-c03-certification-review",
  "Cloudfront 502 Bad gateway 에러 처리하기":
    "cloudfront-502-bad-gateway-troubleshooting",
  "AWS Lambda와 SST Warm 옵션의 정확한 이해 (서버리스 배포 시 알아야 할 개념)":
    "understanding-aws-lambda-sst-warm-option",
  "SST로 클라이언트 웹 무료로 배포하기": "deploy-web-app-free-with-sst",
  "sst 배포중 발생 이슈 해결하기": "troubleshooting-sst-deployment-issues",
  "클라우드 인프라 시각화로 숨은 낭비 찾는 법":
    "find-cloud-waste-with-infrastructure-visualization",

  // Next.js & Performance
  "북마크 이슈로 시작된 효율적인 세션 관리로 Next.js 성능 개선":
    "nextjs-performance-improvement-with-session-management",
  "Next.js x Supabase 429 Invalid Refresh Token":
    "nextjs-supabase-429-invalid-refresh-token",

  // Notion & Integration
  "Notion Calendar, Notion API로 일정 알림 슬랙 연동하기 - 1편":
    "notion-calendar-slack-integration-part-1",
  "Notion Calendar, Notion API로 일정 알림 슬랙 연동하기 - 2편":
    "notion-calendar-slack-integration-part-2",

  // Development & Troubleshooting
  "Cannot read properties of undefined (reading 'prototype')":
    "cannot-read-properties-of-undefined-prototype",

  // Projects & Blog
  "Obsidian, S3로 개인 블로그 만들기": "build-personal-blog-with-obsidian-s3",
  "첫번째 사이드 프로젝트 개발 회고": "first-side-project-retrospective",
};

/**
 * Get new slug from legacy title
 * @param legacyTitle - Original Korean title from URL
 * @returns New slug or null if not found
 */
export function getNewSlug(legacyTitle: string): string | null {
  return POST_REDIRECTS[legacyTitle] || null;
}

/**
 * Get all legacy titles (for reference)
 */
export function getLegacyTitles(): string[] {
  return Object.keys(POST_REDIRECTS);
}

/**
 * Reverse mapping: slug -> original title
 * Used to fetch the correct file from S3
 */
const SLUG_TO_TITLE: Record<string, string> = Object.entries(
  POST_REDIRECTS
).reduce(
  (acc, [title, slug]) => {
    acc[slug] = title;
    return acc;
  },
  {} as Record<string, string>
);

/**
 * Get original title from slug
 * @param slug - New SEO-friendly slug
 * @returns Original title or null if not found
 */
export function getOriginalTitle(slug: string): string | null {
  return SLUG_TO_TITLE[slug] || null;
}
